<footer class="footer-modern">

  <svg class="footer-bg" viewBox="0 0 1440 520" preserveAspectRatio="none">
    <path d="M0 267 Q0 169 169 174 L1173 174 Q1440 169 1440 0 V580 H0 Z" fill="#3cab8d" />
  </svg>
  
  <svg class="footer-bg-mobile" viewBox="0 0 1440 1000" preserveAspectRatio="none">
    <path d="M0 261 Q18 176 228 172 L1126 172 Q1440 178 1440 47 V1000 H0 Z" fill="#3cab8d" />
  </svg>

  <div class="container footer-content">
    <div class="footer-logo-wrap">
      <img src="https://credique-us-assets.s3.us-west-2.amazonaws.com/img/logos/lets-encrypt.webp"
        alt="Let's Encrypt Secured" class="footer-logo">
    </div>

    <div class="footer-top">
      <p class="copyright">
        <strong>(c) 2026 CREDIQUE LLC.</strong> All Rights Reserved.
      </p>
      <nav class="footer-links">
        <a routerLink="/">Home</a>
        <a routerLink="/privacy" target="_blank" id="link-privacy-policy">Privacy Policy</a>
        <a routerLink="/terms" target="_blank" id="link-terms-and-conditions">Terms of Service</a>
        <a routerLink="/contact" target="_blank" id="link-contact-us">Contact</a>
      </nav>
    </div>

    <div class="footer-legal fst-italic">
      <p>*7-Day Free Trial For Financeify. After 7-Days, you will be billed $39.95 monthly
        for continued subscription access to the Financeify Platform. The information provided
        on this financial profile platform is for general informational purposes only. Users
        should not solely rely on the content provided on this platform for making financial
        decisions.</p>
    </div>

  </div>
</footer>